module.exports = __webpack_public_path__ + "mo/img/board_03.daa619be.png";